export default "__VITE_ASSET__CqCZ1C0W__"